import { ATTENDANCE } from "../actions/utilities";

const INITIAL_STATE = {
  employeeCheckInOrOutLoading: false,
  employeeCheckInOrOutSuccess: false,
  employeeCheckInOrOutFailure: false,
  employeeCheckInOrOutError: null,
  employeeCheckInOrOut: [],
  lateCheckInLoading: false,
  lateCheckInSuccess: false,
  lateCheckInFailure: false,
  lateCheckInError: null,
  lateCheckIn: [],

  getEmployeeTodayAttendanceLoading: false,
  getEmployeeTodayAttendanceSuccess: false,
  getEmployeeTodayAttendanceFailure: false,
  getEmployeeTodayAttendanceError: null,
  getEmployeeTodayAttendance: [],

  getAttendanceReportByAdminLoading: false,
  getAttendanceReportByAdminSuccess: false,
  getAttendanceReportByAdminFailure: false,
  getAttendanceReportByAdminError: null,
  getAttendanceReportByAdmin: [],

  getLeaveRequestLoading: false,
  getLeaveRequestSuccess: false,
  getLeaveRequestFailure: false,
  getLeaveRequestError: null,
  getLeaveRequest: [],

  getShortLeaveLoading: false,
  getShortLeaveSuccess: false,
  getShortLeaveFailure: false,
  getShortLeaveError: null,
  getShortLeave: [],

  approveLeaveRequestLoading: false,
  approveLeaveRequestSuccess: false,
  approveLeaveRequestFailure: false,
  approveLeaveRequestError: null,
  approveLeaveRequest: [],

  getEmployeesAttendanceLoading: false,
  getEmployeesAttendanceSuccess: false,
  getEmployeesAttendanceFailure: false,
  getEmployeesAttendanceError: null,
  empTodayAttendance: null,

  shortBreakLoading: false,
  shortBreakSuccess: false,
  shortBreakFailure: false,
  shortBreakError: null,
  shortBreak: [],

  endBreakLoading: false,
  endBreakSuccess: false,
  endBreakFailure: false,
  endBreakError: null,
  getBreakTypesLoading: false,
  getBreakTypesSuccess: false,
  getBreakTypesFailure: false,
  getBreakTypesError: [],

  markAttendanceLoading: false,
  markAttendanceSuccess: false,
  markAttendanceFailure: false,
  marAttendanceError: null,
  markAttendanceResult: null,

  checkoutLoading: false,
  checkoutSuccess: false,
  checkoutFailure: false,
  checkoutError: null,
  checkoutResult: null,

  todayAttendanceSummaryLoading: true,
  todayAttendanceSummarySuccess: false,
  todayAttendanceSummaryFailure: false,
  todayAttendanceSummaryError: null,
  todayAttendanceSummary: [],

  attendanceSummaryLoading: true,
  attendanceSummarySuccess: false,
  attendanceSummaryFailure: false,
  attendanceSummaryError: null,
  attendanceSummary: [],

  attendanceReportLoading: true,
  attendanceReportSuccess: false,
  attendanceReportFailure: false,
  attendanceReportError: null,
  attendanceReport: [],

  leaveRequestsListLoading: true,
  leaveRequestsListSuccess: false,
  leaveRequestsListFailure: false,
  leaveRequestsListError: null,
  leaveRequestsData: [],

  LeaveApprovalLoading: false,
  LeaveApprovalSuccess: false,
  LeaveApprovalFailure: false,
  LeaveApprovalError: null,
  LeaveApproval: [],

  dailyAttendanceListLoading: false,
  dailyAttendanceListSuccess: true,
  dailyAttendanceListFailure: false,
  dailyAttendanceListError: null,
  dailyAttendanceList: [],

  createLeaveRequestLoading: false,
  createLeaveRequestSuccess: true,
  createLeaveRequestFailure: false,
  createLeaveRequestError: null,
  createLeaveRequest: [],
};

export const attendanceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ATTENDANCE.LEAVE_REQUEST_REQUEST:
      return {
        ...state,
        createLeaveRequestFailure: false,
        createLeaveRequestLoading: true,
        createLeaveRequestSuccess: false,
        createLeaveRequestError: null,
      };
    case ATTENDANCE.LEAVE_REQUEST_SUCCESS:
      return {
        ...state,
        createLeaveRequestFailure: false,
        createLeaveRequestLoading: false,
        createLeaveRequestSuccess: true,
        createLeaveRequestError: null,
      };
    case ATTENDANCE.LEAVE_REQUEST_FAILURE:
      return {
        ...state,
        createLeaveRequestFailure: true,
        createLeaveRequestLoading: false,
        createLeaveRequestSuccess: false,
        createLeaveRequestError: null,
      };
    case ATTENDANCE.LATE_CHECK_IN_REQUEST:
      return {
        ...state,
        lateCheckInFailure: false,
        lateCheckInLoading: true,
        lateCheckInSuccess: false,
        lateCheckInError: null,
      };
    case ATTENDANCE.LATE_CHECK_IN_SUCCESS:
      return {
        ...state,
        lateCheckInFailure: false,
        lateCheckInLoading: false,
        lateCheckInSuccess: true,
        lateCheckInError: null,
        lateCheckIn: action.payload,
      };
    case ATTENDANCE.LATE_CHECK_IN_FAILURE:
      return {
        ...state,
        lateCheckInFailure: true,
        lateCheckInLoading: false,
        lateCheckInSuccess: false,
        lateCheckInError: action.payload,
      };
    case ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_REQUEST:
      return {
        ...state,
        getEmployeeTodayAttendanceLoading: true,
        getEmployeeTodayAttendanceSuccess: false,
        getEmployeeTodayAttendanceFailure: false,
        getEmployeeTodayAttendanceError: null,
      };
    case ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_SUCCESS:
      return {
        ...state,
        getEmployeeTodayAttendanceLoading: false,
        getEmployeeTodayAttendanceSuccess: true,
        getEmployeeTodayAttendanceFailure: false,
        getEmployeeTodayAttendanceError: null,
        empTodayAttendance: action.payload,
      };
    case ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_FAILURE:
      return {
        ...state,
        getEmployeeTodayAttendanceLoading: false,
        getEmployeeTodayAttendanceSuccess: false,
        getEmployeeTodayAttendanceFailure: true,
        getEmployeeTodayAttendanceError: action.payload,
      };

    case ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_REQUEST:
      return {
        ...state,
        getAttendanceReportByAdminLoading: true,
        getAttendanceReportByAdminSuccess: false,
        getAttendanceReportByAdminFailure: false,
        getAttendanceReportByAdminError: null,
      };
    case ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_SUCCESS:
      return {
        ...state,
        getAttendanceReportByAdminLoading: false,
        getAttendanceReportByAdminSuccess: true,
        getAttendanceReportByAdminFailure: false,
        getAttendanceReportByAdminError: null,
        getAttendanceReportByAdmin: action.payload,
      };
    case ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_FAILURE:
      return {
        ...state,
        getAttendanceReportByAdminLoading: false,
        getAttendanceReportByAdminSuccess: false,
        getAttendanceReportByAdminFailure: true,
        getAttendanceReportByAdminError: action.payload,
      };

    case ATTENDANCE.EMPLOYEE_CHECK_IN_OR_OUT_REQUEST:
      return {
        ...state,
        employeeCheckInOrOutLoading: true,
        employeeCheckInOrOutSuccess: false,
        employeeCheckInOrOutFailure: false,
        employeeCheckInOrOutError: null,
      };

    case ATTENDANCE.EMPLOYEE_CHECK_IN_OR_OUT_SUCCESS:
      return {
        ...state,
        employeeCheckInOrOutLoading: false,
        employeeCheckInOrOutSuccess: true,
        employeeCheckInOrOutFailure: false,
        employeeCheckInOrOutError: null,
        employeeCheckInOrOut: action.payload,
      };
    case ATTENDANCE.EMPLOYEE_CHECK_IN_OR_OUT_FAILURE:
      return {
        ...state,
        employeeCheckInOrOutLoading: false,
        employeeCheckInOrOutSuccess: false,
        employeeCheckInOrOutFailure: true,
        employeeCheckInOrOutError: action.payload,
      };
    case ATTENDANCE.GET_SHORT_LEAVE_REQUEST:
      return {
        ...state,
        getShortLeaveLoading: true,
        getShortLeaveSuccess: false,
        getShortLeaveFailure: false,
        getShortLeaveError: null,
      };
    case ATTENDANCE.GET_SHORT_LEAVE_SUCCESS:
      return {
        ...state,
        getShortLeaveLoading: false,
        getShortLeaveSuccess: true,
        getShortLeaveFailure: false,
        getShortLeaveError: null,
        getShortLeave: action.payload,
      };
    case ATTENDANCE.GET_SHORT_LEAVE_FAILURE:
      return {
        ...state,
        getShortLeaveLoading: false,
        getShortLeaveSuccess: false,
        getShortLeaveFailure: true,
        getShortLeaveError: action.payload,
      };
    case ATTENDANCE.SHORT_BREAK_REQUEST:
      return {
        ...state,
        shortBreakLoading: true,
        shortBreakSuccess: false,
        shortBreakFailure: false,
        shortBreakError: null,
        shortBreak: [],
      };
    case ATTENDANCE.SHORT_BREAK_SUCCESS:
      return {
        ...state,
        shortBreakLoading: false,
        shortBreakSuccess: true,
        shortBreakFailure: false,
        shortBreakError: null,
        shortBreak: action.payload,
      };
    case ATTENDANCE.SHORT_BREAK_FAILURE:
      return {
        ...state,
        shortBreakLoading: false,
        shortBreakSuccess: true,
        shortBreakFailure: false,
        shortBreakError: action.payload,
        shortBreak: [],
      };
    case ATTENDANCE.END_BREAK_REQUEST:
      return {
        ...state,
        endBreakLoading: true,
        endBreakSuccess: false,
        endBreakFailure: false,
        endBreakError: null,
      };
    case ATTENDANCE.END_BREAK_SUCCESS:
      let oBreak = state.getEmployeeTodayAttendance;
      for (let i = 0; i < oBreak.breaks.length; i++) {
        if (oBreak.breaks[i].breakId === action.payload) {
          oBreak.breaks[i].breakEnd = new Date();
        }
      }
      return {
        ...state,
        endBreakLoading: false,
        endBreakSuccess: true,
        endBreakFailure: false,
        endBreakError: null,
        getBreak: oBreak,
      };
    case ATTENDANCE.END_BREAK_FAILURE:
      return {
        ...state,
        endBreakLoading: false,
        endBreakSuccess: false,
        endBreakFailure: true,
        endBreakError: action.payload,
      };
    case ATTENDANCE.GET_BREAK_TYPES_REQUEST:
      return {
        ...state,
        getBreakTypesLoading: true,
        getBreakTypesSuccess: false,
        getBreakTypesFailure: false,
        getBreakTypesError: null,
      };
    case ATTENDANCE.GET_BREAK_TYPES_SUCCESS:
      return {
        ...state,
        getBreakTypesLoading: false,
        getBreakTypesSuccess: true,
        getBreakTypesFailure: false,
        getBreakTypesError: null,
        getBreakTypes: action.payload,
      };
    case ATTENDANCE.GET_BREAK_TYPES_FAILURE:
      return {
        ...state,
        getBreakTypesLoading: false,
        getBreakTypesSuccess: false,
        getBreakTypesFailure: true,
        getBreakTypesError: action.payload,
      };
    case ATTENDANCE.MARK_ATTENDANCE_REQUEST:
      return {
        ...state,
        markAttendanceLoading: true,
        markAttendanceSuccess: false,
        markAttendanceFailure: false,
        marAttendanceError: null,
        markAttendanceResult: null,
      };
    case ATTENDANCE.MARK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        markAttendanceLoading: false,
        markAttendanceSuccess: true,
        markAttendanceFailure: false,
        marAttendanceError: null,
        markAttendanceResult: true,
      };
    case ATTENDANCE.MARK_ATTENDANCE_FAILURE:
      return {
        ...state,
        markAttendanceLoading: false,
        markAttendanceSuccess: false,
        markAttendanceFailure: true,
        marAttendanceError: action.payload,
        markAttendanceResult: null,
      };

    case ATTENDANCE.CHECKOUT_REQUEST:
      return {
        checkoutLoading: true,
        checkoutSuccess: false,
        checkoutFailure: false,
        checkoutError: null,
        checkoutResult: null,
      };
    case ATTENDANCE.CHECKOUT_SUCCESS:
      return {
        checkoutLoading: false,
        checkoutSuccess: true,
        checkoutFailure: false,
        checkoutError: null,
        checkoutResult: action.payload,
      };
    case ATTENDANCE.CHECKOUT_FAILURE:
      return {
        checkoutLoading: false,
        checkoutSuccess: false,
        checkoutFailure: true,
        checkoutError: action.payload,
        checkoutResult: null,
      };
    case ATTENDANCE.ATTENDANCE_REPORT_REQUEST:
      return {
        ...state,
        attendanceReportLoading: true,
        attendanceReportSuccess: false,
        attendanceReportFailure: false,
        attendanceReportError: null,
        attendanceReport: [],
      };
    case ATTENDANCE.ATTENDANCE_REPORT_SUCCESS:
      return {
        ...state,
        attendanceReportLoading: false,
        attendanceReportSuccess: true,
        attendanceReportFailure: false,
        attendanceReportError: null,
        attendanceReport: action.payload,
      };
    case ATTENDANCE.ATTENDANCE_REPORT_FAILURE:
      return {
        ...state,
        attendanceReportLoading: false,
        attendanceReportSuccess: false,
        attendanceReportFailure: true,
        attendanceReportError: action.payload,
        attendanceReport: [],
      };
    case ATTENDANCE.TODAY_ATTENDANCE_SUMMARY_REQUEST:
      return {
        ...state,
        todayAttendanceSummaryLoading: true,
        todayAttendanceSummarySuccess: false,
        todayAttendanceSummaryFailure: false,
        todayAttendanceSummaryError: null,
        todayAttendanceSummary: [],
      };
    case ATTENDANCE.TODAY_ATTENDANCE_SUMMARY_SUCCESS:
      // console.log("i am in attednance reduccer ::", action.payload)
      return {
        ...state,
        todayAttendanceSummaryLoading: false,
        todayAttendanceSummarySuccess: true,
        todayAttendanceSummaryFailure: false,
        todayAttendanceSummaryError: null,
        todayAttendanceSummary: action.payload,
      };
    case ATTENDANCE.TODAY__ATTENDANCE_SUMMARY_FAILURE:
      return {
        ...state,
        todayAttendanceSummaryLoading: false,
        todayAttendanceSummarySuccess: false,
        todayAttendanceSummaryFailure: false,
        todayAttendanceSummaryError: action.payload,
        todayAttendanceSummary: [],
      };

    /////////////
    case ATTENDANCE.ATTENDANCE_SUMMARY_REQUEST:
      return {
        ...state,
        attendanceSummaryLoading: true,
        attendanceSummarySuccess: false,
        attendanceSummaryFailure: false,
        attendanceSummaryError: null,
        attendanceSummary: [],
      };
    case ATTENDANCE.ATTENDANCE_SUMMARY_SUCCESS:
      return {
        ...state,
        attendanceSummaryLoading: false,
        attendanceSummarySuccess: true,
        attendanceSummaryFailure: false,
        attendanceSummaryError: null,
        attendanceSummary: action.payload,
      };
    case ATTENDANCE.ATTENDANCE_SUMMARY_FAILURE:
      return {
        ...state,
        attendanceSummaryLoading: false,
        attendanceSummarySuccess: false,
        attendanceSummaryFailure: false,
        attendanceSummaryError: action.payload,
        attendanceSummary: [],
      };
    /////////////

    case ATTENDANCE.LEAVE_REQUEST_LIST_REQUEST:
      return {
        ...state,
        leaveRequestsListLoading: true,
        leaveRequestsListSuccess: false,
        leaveRequestsListFailure: false,
        leaveRequestsListError: null,
        leaveRequestsData: [],
      };
    case ATTENDANCE.LEAVE_REQUEST_LIST_SUCCESS:
      // console.log('reducer =>  ATTENDANCE.LEAVE_REQUEST_LIST_SUCCESS', action.payload)
      return {
        ...state,
        leaveRequestsListLoading: false,
        leaveRequestsListSuccess: true,
        leaveRequestsListFailure: false,
        leaveRequestsListError: null,
        leaveRequestsData: action.payload,
      };
    case ATTENDANCE.LEAVE_REQUEST_LIST_FAILURE:
      return {
        ...state,
        leaveRequestsListLoading: false,
        leaveRequestsListSuccess: false,
        leaveRequestsListFailure: true,
        leaveRequestsListError: action.payload,
        leaveRequestsData: [],
      };

    case ATTENDANCE.LEAVE_APPROVAL_REQUEST:
      return {
        ...state,
        LeaveApprovalLoading: true,
        LeaveApprovalSuccess: false,
        LeaveApprovalFailure: false,
        LeaveApprovalError: null,
        LeaveApproval: [],
      };
    case ATTENDANCE.LEAVE_APPROVAL_SUCCESS:
      var info = action.info;
      var request =
        state.leaveRequestsData.leaveRequestsList[info.requestIndex];
      request.approvalStatus = info.status;
      request.approvalStatusId = info.currentApprovalStatusId;
      state.leaveRequestsData.leaveRequestsList[info.requestIndex] = request;

      var statusSummary = state.leaveRequestsData.approvalStatusSummary;
      // console.log('reducer  info=>', info, statusSummary);
      // reduce count : status updated from
      if (info.oldApprovalStatusId == 147) {
        statusSummary.rejected -= 1;
      } else if (info.oldApprovalStatusId == 148) {
        statusSummary.paidApproved -= 1;
      } else if (info.oldApprovalStatusId == 149) {
        statusSummary.unPaidApproved -= 1;
      } else if (info.oldApprovalStatusId == 150) {
        statusSummary.pending -= 1;
      }

      //add count : statys upadted to
      if (info.currentApprovalStatusId == 147) {
        statusSummary.rejected += 1;
      } else if (info.currentApprovalStatusId == 148) {
        statusSummary.paidApproved += 1;
      } else if (info.currentApprovalStatusId == 149) {
        statusSummary.unPaidApproved += 1;
      } else if (info.currentApprovalStatusId == 150) {
        statusSummary.pending += 1;
      }
      state.leaveRequestsData.approvalStatusSummary = statusSummary;
      return {
        ...state,
        LeaveApprovalLoading: false,
        LeaveApprovalSuccess: true,
        LeaveApprovalFailure: false,
        LeaveApprovalError: null,
        LeaveApproval: action.payload,
      };
    case ATTENDANCE.LEAVE_APPROVAL_FAILURE:
      return {
        ...state,
        LeaveApprovalLoading: false,
        LeaveApprovalSuccess: false,
        LeaveApprovalFailure: true,
        LeaveApprovalError: action.payload,
        LeaveApproval: [],
      };

    /////////////
    case ATTENDANCE.DAILY_ATTENDANCE_REQUEST:
      return {
        ...state,
        dailyAttendanceListLoading: true,
        dailyAttendanceListSuccess: false,
        dailyAttendanceListFailure: false,
        dailyAttendanceListError: null,
      };
    case ATTENDANCE.DAILY_ATTENDANCE_SUCCESS:
      if (action.payload && action.payload.length > 0) {
        //var lst = state.dailyAttendanceList;
        // console.log('existing attendance data :::', lst);
        // for (let a = 0; a < action.payload.length; a++) {
        //     lst.push(action.payload[a]);
        // }
        state.dailyAttendanceList = action.payload;
        // state.attendanceSummary.all = state.dailyAttendanceList.length;
        // state.attendanceSummary.offBase = state.dailyAttendanceList.filter(x => x.checkIn != null && x.isOffBase).length;
        // state.attendanceSummary.present = state.dailyAttendanceList.filter(x => x.checkIn != null && (x.isOnLeave == null || !x.isOnLeave)).length;
        // state.attendanceSummary.inHouse = state.dailyAttendanceList.filter(x => x.checkIn != null && (x.isOffBase == null || !x.isOffBase)).length;
        // state.attendanceSummary.absent = state.attendanceSummary.all - state.attendanceSummary.present;
        // state.attendanceSummary.break = state.dailyAttendanceList.filter(x => x.break).length;
      }
      return {
        ...state,
        dailyAttendanceListLoading: false,
        dailyAttendanceListSuccess: true,
        dailyAttendanceListFailure: false,
        dailyAttendanceListError: null,
        //dailyAttendanceList: action.payload
      };
    default:
      return state;
  }
};
